import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';
import strings from '../utils/strings';

import getFetchOptions from '../utils/getFetchOptions';

export default function createAdminClass(
	usersIds,
	adminId,
	subsId,
	className,
	groupId
) {
	return fetch(
		`${ENDPOINT_URL}/adminclass`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				usersIds,
				adminId,
				subsId,
				className,
				groupId,
			}),
		})
	)
		.then((response) => {
			if (response.status === 409) {
				alert(strings.classexistchoosename);
			} else if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
